import React from "react";
import { HiOutlineDocumentText } from "react-icons/hi"; // Using react-icons as requested before
import { IoWarningOutline } from "react-icons/io5";
import { formatPrice } from "../../utils/formatPrice";

const OrderItems = ({ orderData }) => {
  const order = orderData?.data?.order;
  const items = order?.items || [];

  if (!order) {
    return (
      <div className="card shadow-sm border-0 rounded-4 order-items-card">
        <div className="card-body p-4">
          <div className="text-center text-muted py-3">
            لا توجد بيانات طلب متاحة
          </div>
        </div>
      </div>
    );
  }

  const total = order.pricing?.total_amount || 0;

  return (
    <div className="card shadow-sm border-0 rounded-4">
      <div className="card-body p-4">
        {/* Header */}
        <div className="d-flex align-items-center mb-3">
          <HiOutlineDocumentText className="text-success me-2 fs-4" />
          <h6 className="mb-0 fw-bold text-dark">عناصر الطلب</h6>
          <span className="badge bg-primary ms-2">{items.length} منتج</span>
        </div>

        {/* Table Container */}
        <div className="table-responsive border rounded-3 ">
          <table className="table mb-0 align-middle">
            <thead className="bg-light text-muted small">
              <tr>
                <th className="ps-4 fw-normal border-0">المنتج</th>
                <th className="text-center fw-normal border-0">الكمية</th>
                <th className="text-center fw-normal border-0">السعر</th>
                <th className="text-center fw-normal border-0">الحالة</th>
              </tr>
            </thead>
            <tbody>
              {items.length > 0 ? (
                items.map((item, index) => (
                  <tr
                    key={item.id}
                    className={
                      item.status === "out_of_stock" ? "row-out-of-stock" : ""
                    }
                  >
                    <td
                      className={`ps-4 fw-bold ${item.action_status === "replaced" ? "text-warning" : item.action_status === "refunded" ? "text-danger" : "text-dark"} border-bottom-light`}
                    >
                      {item.product?.name}
                    </td>
                    <td
                      className={`text-center border-bottom-light  ${item.action_status === "refunded" ? "text-danger" : item.action_status === "replaced" ? "text-warning" : ""}`}
                    >
                      {item.quantity}
                    </td>
                    <td
                      className={`text-center border-bottom-light ${item.action_status === "refunded" ? "text-danger" : item.action_status === "replaced" ? "text-warning" : ""}`}
                    >
                      {item.total_price
                        ? formatPrice(item.currency_factor, item.total_price)
                        : " "}
                    </td>
                    <td className="text-center text-muted border-bottom-light">
                      {item.action_status === "refunded" ? (
                        <span className="d-flex align-items-center justify-content-center gap-1 text-danger">
                          <IoWarningOutline /> تم استرداده
                        </span>
                      ) : item.action_status === "replaced" ? (
                        <span className="d-flex align-items-center justify-content-center gap-1 text-warning">
                          <IoWarningOutline /> مستبدل
                        </span>
                      ) : null}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-4">
                    لا توجد عناصر في هذا الطلب
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr className="bg-light bg-opacity-50">
                <td className="ps-4 fw-bold py-3" colSpan="2">
                  الإجمالي
                </td>
                <td className="text-end pe-4 fw-bold py-3" colSpan="2">
                  {formatPrice(
                    order.pricing.currency_factor,
                    order.pricing.total_amount,
                  )}{" "}
                  {order.pricing.symbol_currency}
                </td>
              </tr>
              <tr className="bg-secondary bg-opacity-50">
                <td className="ps-4 fw-bold text-success py-3" colSpan="2">
                  الإجمالي النهائي{" "}
                </td>
                <td
                  className="text-end text-success pe-4 fw-bold py-3"
                  colSpan="2"
                >
                  {order?.pricing?.final_amount /
                    order?.pricing?.currency_factor || 0}{" "}
                  {order.pricing.symbol_currency}
                </td>
              </tr>
              {order.pricing && (
                <tr className="bg-light bg-opacity-25">
                  <td className="ps-4 text-muted small" colSpan="2">
                    التفاصيل المالية
                  </td>
                  <td className="text-end pe-4 text-muted small" colSpan="2">
                    <div>
                      الخصم:{" "}
                      {order.pricing.discount_amount /
                        order.pricing.currency_factor || 0}{" "}
                      {order.pricing.symbol_currency}
                    </div>
                    <div>
                      رسوم التوصيل:{" "}
                      {order.pricing.delivery_fee /
                        order.pricing.currency_factor || 0}{" "}
                      {order.pricing.symbol_currency}
                    </div>
                    <div>
                      الضريبة:{" "}
                      {order.pricing.tax_amount /
                        order.pricing.currency_factor || 0}{" "}
                      {order.pricing.symbol_currency}
                    </div>
                    {order.pricing.tip_amount > 0 && (
                      <div>
                        الإكرامية:{" "}
                        {order.pricing.tip_amount /
                          order.pricing.currency_factor}{" "}
                        {order.pricing.symbol_currency}
                      </div>
                    )}
                  </td>
                </tr>
              )}
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderItems;
